<div class="login-bg login2">
  <section class="login-main">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-6 col-md-offset-3">
          <div class="loginpage-logo">
            <img class="login-logo-img" src={{logo}} alt="MFG Logo">
          </div>
          <div id="login-box-login">
            <div class="background-white-login">
              <div class="tabbable-line-login">
                <ul class="nav nav-tabs login-tabs">
                  <li class="parent50 align-li active"><a>Sign in</a></li>
                </ul>
                <div class="tab-content-login">
                  <div id="login" class="active loginregister">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="login-page-title">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="login-page-header">{{ loginWelcomeTitle }}</div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="login-page-subheader">{{ loginWelcomeSubtitle }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <form name="form" (ngSubmit)="onLogin()" #f="ngForm" novalidate>
                        <div class="form-group login-form-group"
                          [ngClass]="{ 'has-error': !username.valid && (f.form.controls.username?.dirty || f.form.controls.username?.touched) }">
                          <label for="username">Email</label>
                          <input type="text" class="form-control" [(ngModel)]="loginModel.username" #username="ngModel"
                            name="username" required />
                          <div
                            *ngIf="!username.valid && (f.form.controls.username?.dirty || f.form.controls.username?.touched)"
                            class="help-block">Email is required</div>
                        </div>
                        <div class="form-group login-form-group"
                              [ngClass]="{ 'has-error':!password.valid && (f.form.controls.password?.dirty || f.form.controls.password?.touched) }">
                              <label for="password">Password</label>
                              <div class="password-input-wrap">
                                <input type="password" class="form-control" [(ngModel)]="loginModel.password" #password="ngModel" name="password" required [type]="passwordVisible ? 'text' : 'password'" />
                                <button type="button" class="password-toggle-btn text-inverse" (click)="togglePasswordVisibility()">
                                  <i class="fa" [ngClass]="passwordVisible ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </button>
                              </div>
                              <div
                                *ngIf="!password.valid && (f.form.controls.password?.dirty || f.form.controls.password?.touched)"
                                class="help-block">Password is required</div>
                              </div>
                        <div class="row m-t-25 text-left">
                          <div class="col-12">
                            <div class="checkbox-fade fade-in-primary d-">
                              <label>
                                <input type="checkbox" [(ngModel)]="loginModel.isRemember"
                                  class="ng-untouched ng-pristine ng-valid" name="isRemember">
                                <span class="cr">
                                  <i class="cr-icon fa fa-check txt-primary"></i>
                                </span>
                                <span class="text-inverse">Remember me</span>
                              </label>
                            </div>
                            <div class="forgot-phone text-right f-right">
                              <a class="text-right f-w-600 activelink" href="#/auth/forgot"> Forgot Password?</a>
                            </div>
                          </div>
                        </div>
                        <div class="input-group login-failed" *ngIf="isLoginFailed">
                          {{errorLoginMessage}}
                        </div>
                        <div class="form-group b-t-10 login-submit-wrap">
                          <button type="submit" [disabled]="!f.form.valid" class="btn btn-md btn-block waves-effect text-center m-b-5 m-t-5 login-btn">Sign In &nbsp; <i class="fa fa-spinner fa-spin" *ngIf="isLoginResonse"></i></button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tabbable-line-login">
                <!-- <ul class="nav nav-tabs login-tabs">
                  <li class="parent50 align-li active"><a>Register</a></li>
                </ul> -->
                <div>
                  <div class="row login-register-row">
                    <div class="col-md-12 p-10">
                     <div class="text-center">
                      <p class="register-text">Not a member? <a (click)='openRegistrationLink()' class="register_here"> Register here.</a></p>
                     </div> 
                    </div>                    
                    <!-- <div class="col-md-6 p-10">
                      <a href="https://www.mfg.com/find-mfg" class="btn btn-md btn-block text-center m-b-20 m-t-20 buyer-btn">Buyer Register</a>
                    </div>
                    <div class="col-md-6 p-10">
                      <a href="https://www.mfg.com/get-leads/" class="btn btn-md btn-block text-center m-b-20 m-t-20 supplier-btn">Manufacturer Register</a>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer class="login-footer">
    <p>Copyright &copy; {{year}}. All Rights Reserved.<span class="pull-right">Release {{currentVersion}}
        &nbsp;</span>
    </p>
  </footer>
</div>
